import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ListChange', null, 3);
        tmp0_serialDesc.c1b('wholeList', true);
        tmp0_serialDesc.c1b('old', true);
        tmp0_serialDesc.c1b('new', true);
        this.u3l_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer().k40(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static l40() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ListChange', $this, 3);
        tmp0_serialDesc.c1b('wholeList', true);
        tmp0_serialDesc.c1b('old', true);
        tmp0_serialDesc.c1b('new', true);
        $this.i40_1 = tmp0_serialDesc;
        return $this;
      }
      m40(encoder, value) {
        var tmp0_desc = this.i40_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.n40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, new (ArrayListSerializer())(this.j40_1), value.n40_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.o40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, this.j40_1, value.o40_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.p40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, this.j40_1, value.p40_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m40(encoder, value instanceof ListChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i40_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, new (ArrayListSerializer())(this.j40_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, this.j40_1, tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, this.j40_1, tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, new (ArrayListSerializer())(this.j40_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, this.j40_1, tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, this.j40_1, tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ListChange().q40(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.i40_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(new (ArrayListSerializer())(this.j40_1)), get_nullable(this.j40_1), get_nullable(this.j40_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.j40_1];
      }
      static k40(typeSerial0) {
        var $this = this.l40();
        $this.j40_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ListChangeClass;
function ListChange() {
  if (ListChangeClass === VOID) {
    class $ {
      constructor(wholeList, old, new_0) {
        Companion_getInstance();
        wholeList = wholeList === VOID ? null : wholeList;
        old = old === VOID ? null : old;
        new_0 = new_0 === VOID ? null : new_0;
        this.n40_1 = wholeList;
        this.o40_1 = old;
        this.p40_1 = new_0;
      }
      toString() {
        return 'ListChange(wholeList=' + toString(this.n40_1) + ', old=' + toString(this.o40_1) + ', new=' + toString(this.p40_1) + ')';
      }
      hashCode() {
        var result = this.n40_1 == null ? 0 : hashCode(this.n40_1);
        result = imul(result, 31) + (this.o40_1 == null ? 0 : hashCode(this.o40_1)) | 0;
        result = imul(result, 31) + (this.p40_1 == null ? 0 : hashCode(this.p40_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListChange()))
          return false;
        if (!equals(this.n40_1, other.n40_1))
          return false;
        if (!equals(this.o40_1, other.o40_1))
          return false;
        if (!equals(this.p40_1, other.p40_1))
          return false;
        return true;
      }
      static q40(seen0, wholeList, old, new_0, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().u3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.n40_1 = null;
        else
          $this.n40_1 = wholeList;
        if (0 === (seen0 & 2))
          $this.o40_1 = null;
        else
          $this.o40_1 = old;
        if (0 === (seen0 & 4))
          $this.p40_1 = null;
        else
          $this.p40_1 = new_0;
        return $this;
      }
    }
    initMetadataForClass($, 'ListChange', ListChange, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ListChangeClass = $;
  }
  return ListChangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2cclvpun048fq,
};
//endregion

//# sourceMappingURL=ListChange.mjs.map
